import { CashManagementGoal } from '../../../goals';
import { colorsByGoalType } from '../../../goals/colors';
import { getMoneyMarketRateStr } from '../helpers';
import { BaseGoalConfig } from './types';

export const CASH_MANAGEMENT: BaseGoalConfig<CashManagementGoal> = {
    iconName: 'GoalCashManagement',
    color: colorsByGoalType['CASH_MANAGEMENT'].primary,
    title: 'Start saving',
    defaultName: 'Cash management',
    getDescription: ({ currentRateInfo }) =>
        `Earn ${getMoneyMarketRateStr(currentRateInfo)} APY* on your cash.`,
    group: 'HIGH_YIELD_CASH_ONLY',
    blogLink: {
        description: 'Earn more on your cash',
        url: 'https://www.withplenty.com/blog/how-to-earn-more-on-your-cash',
    },
    getAnnualReturn: ({ currentRateInfo }) => currentRateInfo.moneyMarketRate,
    getProgress: () => null,
};
